// extracted by mini-css-extract-plugin
export default {"dialog":"_kHdu5brSBorx7ym","heading":"XJX0WvecEA4TjjWN","p":"dhwvUne2TQMf3K7F"};